/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var _ = require("underscore");

    var NEW_ITEM_ENUM = {
        ID: "newItemId",
        CLASS_NAME: "list-component-new-item"
    };
    var NO_ITEMS_ENUM = {
        ID: "noItemsId",
        CLASS_NAME: "list-component-no-items"
    };

    var ListItemModel = BaseModel.extend({
        NEW_ITEM_ID: NEW_ITEM_ENUM.ID,
        NO_ITEMS_ID: NO_ITEMS_ENUM.ID,
        defaults: {
            id: "",
            value: "",
            subText: "",
            iconClass: "",
            tooltip: "",
            className: "",
            notAffectedByFilter: false, // FALSE - visibility will be decided by the List filter (given "visible" is true). TRUE - item will pass the filter method, no matter what is filtered
            active: false, // turns true on item hover
            visible: true,
            enabled: true, // is clickable
            selected: false, // is selected
            actions: {
                add: false,
                select: false,
                remove: false
            }
        },

        isSpecialModel: function() {
            return (this.id === NEW_ITEM_ENUM.ID || this.id === NO_ITEMS_ENUM.ID);
        },
        getClassName: function() {
            return this.get("className");
        },
        getValue: function() {
            return this.get("value");
        },
        setValue: function(value) {
            this.set("value", value);
        },
        getTooltip: function() {
            return this.get("tooltip");
        },
        getActive: function() {
            return this.get("active");
        },
        setActive: function(active) {
            this.set("active", active);
        },
        isActive: function() {
            return (this.getActive() === true);
        },
        getVisible: function() {
            return this.get("visible");
        },
        setVisible: function(visible) {
            this.set("visible", visible);
        },
        isVisible: function() {
            return (this.getVisible() === true);
        },
        getEnabled: function() {
            return this.get("enabled");
        },
        setEnabled: function(enabled) {
            this.set("enabled", enabled);
        },
        isEnabled: function() {
            return (this.getEnabled() === true);
        },
        getSelected: function() {
            return this.get("selected");
        },
        setSelected: function(selected) {
            if (this.isSpecialModel()) {
                return;
            }
            this.set("selected", selected);
        },
        isSelected: function() {
            return (this.getSelected() === true);
        },
        select: function() {
            this.setSelected(true);
        },
        unselect: function() {
            this.setSelected(false);
        },
        toggleSelection: function() {
            this.setSelected(!this.isSelected());
        },
        setTooltip: function(tooltip) {
            this.set("tooltip", tooltip);
        },
        getActions: function() {
            return this.get("actions");
        },
        setActions: function(actions) {
            if (_.has(actions, "add")) {
                this.set("actions.add", actions.add);
            }

            if (_.has(actions, "select")) {
                this.set("actions.select", actions.select);
            }

            if (_.has(actions, "remove")) {
                this.set("actions.remove", actions.remove);
            }
        },
        getFilteredValue: function() {
            return this.get("filteredValue");
        },
        isFilteredByValue: function() {
            return this.get("isFilteredByValue");
        },
        isFilteredBySubText: function() {
            return this.get("isFilteredBySubText");
        },
        getGroup: function() {
            return this.get("group");
        },
        setGroup: function(group) {
            this.set("group", group);
        }
    });

    ListItemModel.NEW_ITEM_ENUM = NEW_ITEM_ENUM;
    ListItemModel.NO_ITEMS_ENUM = NO_ITEMS_ENUM;

    return ListItemModel;
});
